import { Chip } from "@material-ui/core";
import { useMemo } from "react";
import { useTranslate } from "react-admin";
import useUserStatus from "../useUserStatus";

const UserStatusField = ({ record }) => {
  const translate = useTranslate();
  const status = useUserStatus(record);
  const label = useMemo(
    () =>
      translate(`resources.substitutive-declarations-users.status.${status}`),
    [status, translate]
  );
  return (
    <Chip
      color={status === "not_confirmed" ? "secondary" : "primary"}
      label={label}
    />
  );
};
export default UserStatusField;
